import { render, staticRenderFns } from "./Properties.html?vue&type=template&id=6b2e0e66&scoped=true&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.scss?vue&type=style&index=0&id=6b2e0e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e0e66",
  null
  
)

export default component.exports